export default __webpack_public_path__ + "static/media/dots3.1d400a24.svg";